module.exports = __webpack_public_path__ + "img/5.9aa7d7dd.jpeg";